<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Vision',

    metaInfo: { title: 'Vision' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'vision',
        'products',
        'contact-us',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'vision',
      },
    },
  }
</script>
